export default __webpack_public_path__ + "static/media/source-repository.a5beb56a.svg";